export default "__VITE_ASSET__vGn1ACaI__"